import React, { Fragment } from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import StepData from "./components/StepData";
import CancellationPolicy from "./components/CancellationPolicy";
import "./App.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/cancellation-policy" element={<CancellationPolicy />} />
        <Route
          path="/*"
          element={
            <Fragment>
              <StepData />
              <ToastContainer position="top-right" autoClose={3000} />
            </Fragment>
          }
        />
      </Routes>
    </HashRouter>
  );
}

export default App;
